module.exports = __webpack_public_path__ + "img/21_90.07918cb1.png";